/**
 * This behavior listens for the `keydown` event and toggles an alert if caps
 * lock is enabled. It assumes there will only be 1 alert on the page.
 *
 * The alert container should have the class `js-form-caps-lock` and be hidden
 * by default using the `hidden` class.
 *
 * Screen readers will alert the user when the caps lock key is pressed, so the
 * alert should have `aria-hidden="true"` set on it to prevent the screen reader
 * from announcing it twice.
 */
import { on } from "delegated-events";
on("keydown", "body", (e) => {
    // When using the browser autofill (in chrome at least) this gets triggered with a generic
    // Event of type keydown but there's no modifier state to check on it
    if (!(e instanceof KeyboardEvent)) {
        return;
    }
    const capsLockWarning = document.querySelector(".js-form-caps-lock");
    capsLockWarning === null || capsLockWarning === void 0 ? void 0 : capsLockWarning.classList.toggle("hidden", !e.getModifierState("CapsLock"));
});
